import React, { useEffect, useState, Fragment } from 'react';
import ReactPaginate from 'react-paginate';

//Headlessui for MODAL
import { Dialog, Transition } from '@headlessui/react'

//Icons
import { BsXLg } from "react-icons/bs";

//Skeleton
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

//APIS
import { ogrenciListe } from '../../../apis/ogrenci'

const OgrenciListesi = () => {

    const [loading, setLoading] = useState(false) // Skleton için kullanılacak

    //STATES

    const [open, setOpen] = useState(false)
    const [ogrenciId, setOgrenciId] = useState()

    const [pageCount, setPageCount] = useState(0)
    const [offset, setOffset] = useState(0)
    const [perPage, setPerPage] = useState(5); // Sayfa başına gösterilecek öğe sayısı
    const [currentPage, setCurrentPage] = useState(0); // Şu anki sayfa



    //LIST STATE
    const [ogrenciLIST, setOgrenciLIST] = useState([])
    const [filteredOgrenci, setFilteredOgrenci] = useState([])



    //HANDLE FUNCTIONS

    const handleFilter = (value) => {
        const lowercasedValue = value.toLocaleLowerCase('TR').trim()
        const filteredOgrenci = ogrenciLIST.filter(item => {
            //eslint-disable-next-line
            return Object.keys(item).some(key => {
                if (typeof item[key] === 'string') {
                    return item[key].toString().toLocaleLowerCase('TR').includes(lowercasedValue.toLocaleLowerCase('TR'))
                }
            });
        });
        setFilteredOgrenci(filteredOgrenci)
    }


    //API FUNCTIONS

    const getOgrenciLIST = async () => {
        setLoading(true)
        let result = await ogrenciListe()
        if (result.status === 200) {
            setOgrenciLIST(result.data)
            setFilteredOgrenci(result.data)

            safyaHesaplama(result.data.length)
            setLoading(false)
        }
    }
    const safyaHesaplama = (sayi) => {
        setPageCount(Math.ceil(sayi / perPage))
        setOffset(currentPage * perPage)
    }

    useEffect(() => {
        getOgrenciLIST()
        //eslint-disable-next-line
    }, []);


    useEffect(() => {
        safyaHesaplama(filteredOgrenci.length)
        //eslint-disable-next-line
    }, [currentPage, filteredOgrenci, perPage]);

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };




    return (
        <>
            <main className='text-slate-500 text-sm transition-all'>
                <div className="py-5">
                    <div className="w-full px-4 sm:px-6 md:px-8">
                        <div className='container mx-auto flex flex-col md:flex-row justify-between  md:items-start mb-3 md:mb-0'>
                            <h1 className='page-title leading-6 font-normal text-lg mb-2 md:mb-6 text-slate-500'>Öğrenci Listesi</h1>
                        </div>
                        <div className='container mx-auto space-y-4'>
                            <div className='kapsama relative w-full flex flex-col lg:flex-row gap-4'>

                                <div className='w-full'>
                                    <div className='bg-white rounded-lg p-4 min-h-0 overflow-x-auto mb-6'>
                                        <div className='flex justify-between items-center mb-2'>
                                            <h1 className=''>Toplam Kayıtlı Öğrenci Sayısı : {ogrenciLIST?.length}</h1>
                                            <input onChange={(e) => {
                                                setCurrentPage(0)
                                                handleFilter(e.target.value)

                                            }} type='text' placeholder='Ara...' className='sd-form-input w-1/4' />
                                        </div>
                                        {
                                            loading ? <Skeleton baseColor="#e2e8f0" width="100%" count={3} height={20} /> : (
                                                <>
                                                    <table className='w-full table-auto'>
                                                        <thead className='bg-slate-100'>
                                                            <tr>
                                                                <td className='px-4 py-2 whitespace-nowrap'>Öğrenci No</td>
                                                                <td className='px-4 py-2 whitespace-nowrap hidden lg:table-cell'>Ad Soyad</td>
                                                                <td className='px-4 py-2 whitespace-nowrap hidden md:table-cell'>ABD/ASD</td>
                                                                <td className='px-4 py-2 whitespace-nowrap hidden lg:table-cell'>BD/SD</td>
                                                                <td className='px-4 py-2 whitespace-nowrap hidden lg:table-cell'>E-Posta</td>
                                                                <td className='px-4 py-2 whitespace-nowrap hidden lg:table-cell'>Telefon</td>
                                                                <td className='px-4 py-2 whitespace-nowrap sr-only'>İşlemler</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody className='text-xs'>
                                                            {
                                                                filteredOgrenci?.length > 0 ? (
                                                                    filteredOgrenci.slice(offset, offset + perPage).map((item, key) => (
                                                                        <tr key={key} className='even:bg-slate-50 odd:bg-white'>
                                                                            <td className='px-4 py-3 whitespace-nowrap'>
                                                                                <strong className='underline'>{item.ogrenciNo}</strong>
                                                                                <dl className='lg:hidden'>
                                                                                    <dd className='lg:hidden'>{item.ogrenciAdiSoyadi}</dd>
                                                                                    <dd className='lg:hidden'>{item.ogrenciEposta}</dd>
                                                                                    <dd className='lg:hidden'>{item.ogrenciCepNo}</dd>
                                                                                    <dd className='md:hidden'>{item.anabilim?.anabilimName}</dd>
                                                                                </dl>
                                                                            </td>
                                                                            <td className='px-4 py-3 whitespace-nowrap hidden lg:table-cell'>
                                                                                <div>{item.ogrenciAdiSoyadi}</div>
                                                                            </td>
                                                                            <td className='px-4 py-3 hidden md:table-cell'>
                                                                                <div>{item.anabilim?.anabilimName}</div>
                                                                                <dl className='lg:hidden'>
                                                                                    <dd>{item.bilimsanatdali?.bilimsanatdaliName}</dd>
                                                                                </dl>
                                                                            </td>
                                                                            <td className='px-4 py-3 whitespace-nowrap hidden lg:table-cell'>
                                                                                <div>{item.bilimsanatdali?.bilimsanatdaliName}</div>
                                                                            </td>
                                                                            <td className='px-4 py-3 whitespace-nowrap hidden lg:table-cell'>
                                                                                <div>{item.ogrenciEposta}</div>
                                                                            </td>
                                                                            <td className='px-4 py-3 whitespace-nowrap hidden lg:table-cell'>
                                                                                <div>{item.ogrenciCepNo}</div>
                                                                            </td>
                                                                            <td className='px-4 py-3 whitespace-nowrap'>
                                                                                <button
                                                                                    onClick={() => {
                                                                                        setOgrenciId(item.ogrenciId)
                                                                                        setOpen(true)
                                                                                    }}
                                                                                    className='bg-sky-600 text-white hover:bg-sky-700 py-1 px-3 rounded-3xl outline-dashed outline-1 focus:outline-sky-400 outline-offset-2'>
                                                                                    Görüntüle
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={3} className='px-4 py-3'>Kayıt bulunamamıştır.</td>
                                                                    </tr>
                                                                )
                                                            }
                                                        </tbody>
                                                    </table>
                                                    <div className='flex w-full justify-between items-center mt-4 px-4'>
                                                        <div className='flex items-center gap-x-2'>
                                                            <select onChange={(e) => setPerPage(e.target.value)} className='border border-slate-200 rounded-md px-2 py-1'>
                                                                <option value="5">5</option>
                                                                <option value="10">10</option>
                                                                <option value="50">50</option>
                                                                <option value="100">100</option>
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <ReactPaginate
                                                                className='flex items-center gap-x-2 w-full'
                                                                previousLabel="Önceki"
                                                                nextLabel="İleri"
                                                                breakLabel="..."
                                                                pageCount={pageCount}
                                                                marginPagesDisplayed={1}
                                                                onPageChange={handlePageChange}
                                                                containerClassName={'pagination'}
                                                                activeClassName={'text-slate-600 font-semibold border rounded px-2 py-1.5 bg-slate-100 hover:bg-slate-200'}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        }

                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>

                </div>
            </main >
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpen}>
                    <div className="fixed inset-0" />

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-lg">
                                        <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                                            <div className="px-4 sm:px-6">
                                                <div className="flex items-start justify-between">
                                                    <Dialog.Title className="text-base font-semibold leading-6 text-slate-500">
                                                    </Dialog.Title>
                                                    <div className="ml-3 flex h-7 items-center">
                                                        <button
                                                            type="button"
                                                            className="rounded-md bg-white text-slate-400 hover:text-slate-500"
                                                            onClick={() => setOpen(false)}
                                                        >
                                                            <span className="sr-only">Close panel</span>
                                                            <BsXLg className="h-6 w-6" aria-hidden="true" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="relative mt-6 px-4 sm:px-6 text-slate-500">
                                                {
                                                    ogrenciLIST?.filter(item => item.ogrenciId === ogrenciId).map((item, key) => (
                                                        <div key={key} className='text-xs'>
                                                            <div className='space-y-1'>
                                                                <div className='font-semibold text-xl'>{item.ogrenciAdiSoyadi}</div>
                                                                <div className='divide-x-2'>
                                                                    <span className='pr-4'><a href='mailto:selim@odu.edu.tr'>Eposta : {item.ogrenciEposta}</a></span>
                                                                    <span className='pl-4'>Telefon : {item.ogrenciCepNo}</span>
                                                                </div>
                                                                <div>Öğrenci Numarası : {item.ogrenciNo}</div>
                                                            </div>

                                                            <div className='space-y-2 mt-4'>
                                                                <div className='font-semibold'>{item.enstitu?.enstituName}</div>
                                                                <div className=''>{item.anabilim?.anabilimName}</div>
                                                                <div className=''>{item.bilimsanatdali?.bilimsanatdaliName}</div>
                                                            </div>

                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>

        </>
    );
}

export default OgrenciListesi;
